const CONNECT = process.env.GATSBY_CONNECT_URL;
const CONNECT_CLIENT = process.env.GATSBY_CONNECT_CLIENT;
const CONNECT_GATEWAY = process.env.GATSBY_CONNECT_GATEWAY;
const BUCKET_S3 = process.env.BUCKET_S3;
const CLIENT = process.env.CLIENT;
const GRAPHQL_READONLY_TOKEN = "is6gHLFvtdtowu2JwO99SRNGUfUT-4L6";
const INNTOPIA_SALES_ID = process.env.GATSBY_INNTOPIA_SALES || false;

export { CLIENT, CONNECT, CONNECT_CLIENT, CONNECT_GATEWAY, BUCKET_S3, GRAPHQL_READONLY_TOKEN, INNTOPIA_SALES_ID };
